import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICharity, ICharityDetails} from "../../models/charity/response";
import {ICharityQuery} from "../../models/charity/query";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {ICreateCharity, IUpdateCharity} from "../../models/charity/request";
import {createContext} from "react";

export type CharityLoading =
    | "list"
    | "details"
    | "create"
    | "update"
    | "delete";

export interface IInternalState {
  loading: CharityLoading[];
  list?: IBaseListingResponse<ICharity>;
  query: ICharityQuery;
  details?: ICharityDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ICharityDetails) => void;
    createCharity: (request: ICreateCharity) => void;
    updateCharity: (id: number, request: IUpdateCharity) => void;
    deleteCharity: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: ICharityQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createCharity: DEFAULT_FUNCTION,
    updateCharity: DEFAULT_FUNCTION,
    deleteCharity: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const CharityContext = createContext(externalState);

export default CharityContext;